// // utils.js (或者你可以直接在 main.js 中定义这个函数)  
// export function formatDateTime() {  
//     // 创建一个新的 Date 对象，该对象表示当前的日期和时间  
// const currentDate = new Date();  
  
// // 获取年份（四位数）  
// const year = currentDate.getFullYear();  
  
// // 获取月份（从0到11，0表示一月，因此通常要加1）  
// const month = currentDate.getMonth() + 1;  
  
// // 获取日期（从1到31）  
// const day = currentDate.getDate();  
  
// // 获取小时（0到23）  
// const hours = currentDate.getHours();  
  
// // 获取分钟（0到59）  
// const minutes = currentDate.getMinutes();  
  
// // 获取秒（0到59）  
// const seconds = currentDate.getSeconds();  
  
// // 格式化日期和时间字符串  
// const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;  
// const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;  
  
// console.log(`当前的日期是: ${formattedDate}`);  
// console.log(`当前的时间是: ${formattedTime}`);
// return formattedDate
//   }

export default{
    getNowTime(){
            // 创建一个新的 Date 对象，该对象表示当前的日期和时间  
const currentDate = new Date();  
  
// 获取年份（四位数）  
const year = currentDate.getFullYear();  
  
// 获取月份（从0到11，0表示一月，因此通常要加1）  
const month = currentDate.getMonth() + 1;  
  
// 获取日期（从1到31）  
const day = currentDate.getDate();  
  
// 获取小时（0到23）  
const hours = currentDate.getHours();  
  
// 获取分钟（0到59）  
const minutes = currentDate.getMinutes();  
  
// 获取秒（0到59）  
const seconds = currentDate.getSeconds();  
  
// 格式化日期和时间字符串  
const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;  
const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;  
  
console.log(`当前的日期是: ${formattedDate}`);  
console.log(`当前的时间是: ${formattedTime}`);
return formattedDate
    }
}